import { useTranslation } from "react-i18next";

import { useQuery } from "@tanstack/react-query";

import { getAdminPracticeMineralFertilizers, getPracticeMineralFertilizers } from "services";

import { getEnvironment } from "utils";

import { DEFAULT_CACHE_TIME, GET_PRACTICES_FERTILIZERS_MINERAL } from "consts";

import { PracticeFertilizerMineral, WithInjectedName } from "models";

export const useGetPracticeMineralFertilizers = ({ enabled }: { enabled?: boolean }) => {
  // Not having { useSuspense: false } caused unintended UI behavior — like a drawer opening and closing on mount,
  // due to remounting triggered by Suspense fallback.
  // DO NOT REMOVE unless you're explicitly handling Suspense with fallback UIs.
  const { t } = useTranslation("practices", { useSuspense: false });
  const isAdmin = getEnvironment().admin;

  const queryFn = isAdmin ? getAdminPracticeMineralFertilizers : getPracticeMineralFertilizers;

  return useQuery<Array<WithInjectedName<PracticeFertilizerMineral>>>({
    queryKey: [GET_PRACTICES_FERTILIZERS_MINERAL, enabled, isAdmin],
    queryFn: async () => {
      const fertilizers = await queryFn({ enabled });
      return fertilizers.map((f) => ({ ...f, name: t(`mineralFertilizers.${f.translationSlug}`) }));
    },
    gcTime: DEFAULT_CACHE_TIME,
    staleTime: DEFAULT_CACHE_TIME,
  });
};
